import { render, staticRenderFns } from "./PFProfitDistributeReportNew.vue?vue&type=template&id=5832f9b1"
import script from "./PFProfitDistributeReportNew.vue?vue&type=script&lang=js"
export * from "./PFProfitDistributeReportNew.vue?vue&type=script&lang=js"
import style0 from "./PFProfitDistributeReportNew.vue?vue&type=style&index=0&id=5832f9b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports